import React, { useContext, useState } from 'react';
import Button from '@mui/material/Button';

import { AppConfigContext } from '@providers/AppConfigProvider';

interface CustomButtonProps {
  href: string;
  label: string;
  handleClick: () => void;
}

export default function CustomButton({ href, label, handleClick }: CustomButtonProps): React.JSX.Element {
  const { pathRoot } = useContext(AppConfigContext);
  const [isHovered, setIsHovered] = useState(false);
  return (
    <Button
      component="a"
      href={href}
      variant="outlined"
      className="relative border-white rf-btn-black-md hover:bg-rf-yellow text-white hover:border-black group"
      onClick={handleClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <span className="absolute left-1/2 transform -translate-x-1/2 font-bold group-hover:text-black">{label}</span>
      <img
        src={`${pathRoot}/assets/images/common/${
          isHovered ? 'ArrowForwardRoundedIcon_black' : 'ArrowForwardRoundedIcon_white'
        }.svg`}
        className="absolute right-4 w-5 block"
        alt="arrow"
      />
    </Button>
  );
}
